import { actions, idbRestoreState } from '@sloyd/store-base';
import { put, takeEvery } from 'saga-ts';
import { getJson, getString, invokeEvent } from 'shared-base';
import { parsePath } from '../utils/path';
import { customEventChannel } from './channels/channel.customEvent';

export function* restoreAuth() {
  try {
    const token = getString('token');
    const user = getJson('auth');

    if (!token || !user) {
      return;
    }

    invokeEvent('AUTH_COMPLETED', { user, token });
  } catch (err) {
    console.log('err =>', err);
    invokeEvent('sentry', { err });
  }
}

export function* restore() {
  try {
    console.time('idbRestoreState');
    const state = yield idbRestoreState();
    console.timeEnd('idbRestoreState');

    if (!state) {
      return;
    }

    if (state.user) { yield put(actions.user.patch(state.user));} // prettier-ignore
    // if (state.projects) { yield put(actions.projects.setAll(state.projects));} // prettier-ignore
    if (state.palettes) { yield put(actions.palettes.setAll(state.palettes));} // prettier-ignore
    if (state.generators) { yield put(actions.generators.setAll(state.generators));} // prettier-ignore
    if (state.assetPacks) { yield put(actions.assetPacks.setAll(state.assetPacks));} // prettier-ignore

    const p = parsePath();
    if (p.projectId) {
      console.time('getProject');
      // yield call(getProject, p.projectId);
      console.timeEnd('getProject');
    }

    // yield call(onReady);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

// Root saga
export function* root(): Generator<any, void, any> {
  // yield* fork(restoreAuth);

  const channel = customEventChannel('AUTH_COMPLETED');
  yield takeEvery(channel, restore);
}

// Export saga
export const saga = {
  id: 'sloyd.cache',
  type: 'bootstrap',
  root,
  trigger: {},
};
